<template>
    <v-container fluid px-1>

        <v-expansion-panels focusable multiple :value="openPanels">
            <v-expansion-panel>
                <v-expansion-panel-header>{{$t('statistics.titleTaxon') }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <observation-statistics></observation-statistics>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>{{$t('statistics.titleStatus') }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <protection-status></protection-status>
                </v-expansion-panel-content>

            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>{{$t('statistics.titleStatistics') }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <charts-statistics></charts-statistics>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-container>
</template>

<script>
    import ObservationStatistics from './ObservationStatistics'
    import ProtectionStatus from './ProtectionStatus'
    import ChartsStatistics from './ChartsStatistics'

    export default {
        name: 'SpeciesOverview',
        components: {
            ProtectionStatus,
            ObservationStatistics,
            ChartsStatistics
        },
        data() {
            return {
                openPanels: [] // open all panels as soon as data is available
            }
        }
    }

</script>

<style scoped>


</style>